import { useTranslation } from 'react-i18next'

interface TrialExpiredOverlayProps {
  reason?: 'TRIAL_EXPIRED' | 'SUBSCRIPTION_REQUIRED'
  onDismiss: () => void
}

export default function TrialExpiredOverlay({ onDismiss }: TrialExpiredOverlayProps) {
  const { t } = useTranslation('chat')

  return (
    <div className="absolute inset-0 z-50 flex items-center justify-center bg-midnight/80 backdrop-blur-sm">
      <div className="glass-card rounded-2xl p-6 max-w-sm mx-4 text-center space-y-4">
        <h2 className="text-lg font-semibold text-ivory">
          {t('trial.inactiveTitle')}
        </h2>
        <p className="text-sm text-pearl/70">
          {t('trial.inactiveDescription')}
        </p>
        <button
          onClick={onDismiss}
          className="text-xs text-pearl/60 hover:text-pearl/80 transition-colors"
        >
          {t('trial.browsePrevious')}
        </button>
      </div>
    </div>
  )
}
